﻿export class TabScroller {
    private dotnetRef: any;
    private containerRef: HTMLElement;
    private onScrollTimeout: number | null = null;

    constructor(dotNetRef: any, containerRef: HTMLElement) {
        if (!(containerRef instanceof HTMLElement)) {
            console.error("containerRef is not a valid HTMLElement", containerRef);
            return;
        }

        this.dotnetRef = dotNetRef;
        this.containerRef = containerRef;

        this.containerRef.addEventListener('scroll', this.OnScroll.bind(this));
    }

    public async CheckScrollPosition(): Promise<void> {
        const elementWidth = this.containerRef.scrollWidth - this.containerRef.clientWidth;
        const scrollLeft = Math.round(this.containerRef.scrollLeft);
        const canScrollLeft = scrollLeft > 0;
        const canScrollRight = scrollLeft < elementWidth;

        await this.dotnetRef.invokeMethodAsync('UpdateScrollButtons', canScrollLeft, canScrollRight);
    }

    public ScrollLeft(): void {
        this.ScrollBy(-100);
    }

    public ScrollRight(): void {
        this.ScrollBy(100);
    }

    private ScrollBy(offset: number): void {
        this.SetScrollTimeout();
        this.containerRef.scrollBy({ left: offset, behavior: 'smooth' });
    }

    private async OnScroll(): Promise<void> {
        if (this.onScrollTimeout !== null) {
            this.SetScrollTimeout();
            return;
        }

        await this.CheckScrollPosition();
    }

    private SetScrollTimeout(): void {
        clearTimeout(this.onScrollTimeout);

        this.onScrollTimeout = window.setTimeout(() => {
            this.onScrollTimeout = null;
            this.OnScroll();
        }, 200);
    }
}

window['InitTabScroller'] = function (dotNetRef: any, containerRef: HTMLElement) {
    return new TabScroller(dotNetRef, containerRef);
};
